import { createTheme } from "@mui/material";

export const THEME = "dark";
export const NAVBAR_AND_FOOTER_BACKGROUND_COLOR = "black";
export const APP_BACKGROUND_COLOR = "#0C1B2B";
export const APP_COLOR = "#27B6CB";
export const APP_HOVER_COLOR = "#1A8899";
export const TEXT_COLOR = "#FFFFFF";
export const FONT_FAMILY = "Argumentum";
export const SVG_ICON_COLOR = "#FFFFFF";

export const themeObj = {
  dark: {
    background: {
      default: APP_BACKGROUND_COLOR,
    },
  },
};

export const darkTheme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: APP_BACKGROUND_COLOR,
          fontFamily: FONT_FAMILY,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: FONT_FAMILY,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: APP_BACKGROUND_COLOR,
          fontFamily: FONT_FAMILY,
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          color: APP_BACKGROUND_COLOR,
          fontFamily: FONT_FAMILY,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: APP_BACKGROUND_COLOR,
          fontFamily: FONT_FAMILY,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: APP_BACKGROUND_COLOR,
          fontFamily: FONT_FAMILY,
        },
      },
    },
  },

  palette: {
    mode: THEME,
    text: {
      primary: TEXT_COLOR,
    },
    ...themeObj,
  },
  typography: {
    fontFamily: FONT_FAMILY,
  },
});

export const selectOptionsStlye = {
  MenuListProps: {
    sx: {
      backgroundColor: APP_BACKGROUND_COLOR,
    },
  },
};
